import { useMemo } from 'react';

import { SelectedReceiver } from '../components/transaction/SelectedReceiver';
import { useConfig } from '../defaultConfig';

const useNoteMaxLength = (lesserLimit?: boolean): number => {
    const { noteMaxLength, noteMaxLengthSmall } = useConfig();
    return lesserLimit ? noteMaxLengthSmall : noteMaxLength;
};

type UseNoteMaxLengthWithKIDSelectedParams = {
    selectedReceiver?: SelectedReceiver;
    lesserLimit?: boolean;
};
export const useNoteMaxLengthWithKIDSelected = ({
    selectedReceiver,
    lesserLimit,
}: UseNoteMaxLengthWithKIDSelectedParams): number => {
    const noteMaxLength = useNoteMaxLength(lesserLimit);
    const { featureToggles } = useConfig();

    return useMemo(() => {
        if (
            selectedReceiver?.kidFormats &&
            selectedReceiver.kidRequired === true &&
            featureToggles.enableKidValidation
        ) {
            return Math.max.apply(
                null,
                selectedReceiver.kidFormats.map((x) => x.length),
            );
        }
        return noteMaxLength;
    }, [selectedReceiver, noteMaxLength, featureToggles.enableKidValidation]);
};

export default useNoteMaxLength;
